export interface FontStyleFlags {
  bold?: boolean;
  italic?: boolean;
}

/**
 * Canvas/CSS font shorthand for a family stack at a given size, carrying the
 * style flags the element actually applies. That way canvas measurements pick
 * the same face the browser will render with.
 */
export const cssFontShorthand = (fontFamily: string, fontSizePx: number, { bold = false, italic = false }: FontStyleFlags = {}): string =>
  `${italic ? 'italic ' : ''}${bold ? '700 ' : ''}${fontSizePx}px ${fontFamily}`;
